<div class="landing-page">
  <!-- Header Section -->
  <header class="landing-page__header">
    <div class="landing-page__container">
      <div class="landing-page__brand">
        <img src="ACS_small_rgb.jpg" alt="ACS Logo" class="landing-page__logo">
        <div class="landing-page__brand-text">
          <h1 class="landing-page__title">ACS Chapter Portal</h1>
          <p class="landing-page__subtitle">American College of Surgeons</p>
        </div>
      </div>
    </div>
  </header>

  <!-- Main Content -->
  <main class="landing-page__main">
    <div class="landing-page__container">
      
      <!-- Welcome Section -->
      <section class="landing-page__welcome">
        <h2 class="landing-page__welcome-title">Welcome to the Chapter Portal</h2>
        <p class="landing-page__welcome-description">
          Access your chapter information, manage membership, and connect with the ACS community. 
          Please sign in to continue.
        </p>
      </section>

      <!-- Authentication Section -->
      <section class="landing-page__auth">
        <div class="landing-page__auth-card">
          <h3 class="landing-page__auth-title">Choose Sign-In Method</h3>
          
          <div class="landing-page__providers">
            <div 
              class="landing-page__provider"
              [class.landing-page__provider--loading]="isLoading">
              
              <button 
                class="landing-page__provider-button"
                [disabled]="isLoading"
                (click)="authBase.login()">
                
                <div class="landing-page__provider-icon">
                  <span *ngIf="!isLoading">🎯</span>
                  <div *ngIf="isLoading" class="landing-page__spinner"></div>
                </div>
                
                <div class="landing-page__provider-info">
                  <h4 class="landing-page__provider-name">Okta</h4>
                  <p class="landing-page__provider-description">Sign in with Okta SSO</p>
                </div>
                
                <div class="landing-page__provider-arrow">→</div>
              </button>
            </div>
          </div>

          <!-- Features Preview -->
          <div class="landing-page__features">
            <h4 class="landing-page__features-title">Portal Features</h4>
            <div class="landing-page__features-grid">
              <div class="landing-page__feature">
                <span class="landing-page__feature-icon">👥</span>
                <span class="landing-page__feature-text">Member Management</span>
              </div>
              <div class="landing-page__feature">
                <span class="landing-page__feature-icon">💰</span>
                <span class="landing-page__feature-text">Dues Tracking</span>
              </div>
              <div class="landing-page__feature">
                <span class="landing-page__feature-icon">📊</span>
                <span class="landing-page__feature-text">Reports & Analytics</span>
              </div>
              <div class="landing-page__feature">
                <span class="landing-page__feature-icon">🏥</span>
                <span class="landing-page__feature-text">Chapter Information</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>

  <!-- Footer -->
  <footer class="landing-page__footer">
    <div class="landing-page__container">
      <div class="landing-page__footer-content">
        <div class="landing-page__footer-links">
          <a href="https://facs.org" target="_blank" rel="noopener">ACS Website</a>
          <a href="https://facs.org/about-acs/contact" target="_blank" rel="noopener">Support</a>
          <a href="https://facs.org/about-acs/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>
        </div>
        <div class="landing-page__footer-copyright">
          © {{ currentYear }} American College of Surgeons. All rights reserved.
        </div>
      </div>
    </div>
  </footer>
</div>